import { useEffect, useState, RefObject } from 'react'
import { InitialConfigType } from '../../../interfaces'

const initialConfig: InitialConfigType = {
  zoom: 4,
  center: { lat: -27.2008942, lng: 122.0053344 },
  language: 'en',
  region: 'AU',
  disableDefaultUI: true,
  zoomControl: true,
  mapTypeControl: false,
  scaleControl: false,
  streetViewControl: false,
  rotateControl: false,
  fullscreenControl: false,
  keyboardShortcuts: true,
  gestureHandling: 'cooperative'
}

export const useGoogleMap = (
  mapRef: RefObject<HTMLDivElement>
): google.maps.Map | null => {
  const [map, setMap] = useState<google.maps.Map | null>(null)
  useEffect(() => {
    if (!map && mapRef.current) {
      const newMap = new window.google.maps.Map(
        mapRef.current as HTMLElement,
        initialConfig
      )
      setMap(newMap)
    }
  }, [mapRef, map])
  return map
}
